import React from 'react'

import './order-message-list.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
  }
>

const OrderMessageList = ({className, children, ...props}: Props) => (
  <div {...props} className={cn('OrderMessageList', {}, className)}>
    {children}
  </div>
)

export default OrderMessageList
